import { render, staticRenderFns } from "./QuestionForm3.vue?vue&type=template&id=23b8f78a&scoped=true&"
import script from "./QuestionForm3.vue?vue&type=script&lang=js&"
export * from "./QuestionForm3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8f78a",
  null
  
)

export default component.exports